import ReactDOM from 'react-dom/client';
import App from './App';
// import reportWebVitals from './reportWebVitals';
import {
  BrowserRouter as Router,
} from "react-router-dom";
import Provide from "./hooks/hooks.provider"

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Router>
    <Provide>
      <App />
    </Provide>
  </Router>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
